import { Avatar, Icon } from "prism-react";
import type { IconType } from "prism-react";
import type { ComponentProps } from "react";

import { getFileIconType } from "utils/icons";

const PaletteIcon: React.FC<{ type: IconType }> = ({ type }) => (
  <Icon size={4} type={type} />
);

type AvatarProps = ComponentProps<typeof Avatar>;
export const getCommandAvatar = (props: AvatarProps): JSX.Element => {
  return <Avatar {...props} shape="circle" size="s" />;
};

export const getCommandIcon = (type: IconType): JSX.Element => {
  return <PaletteIcon type={type} />;
};

export const getFileIcon = (name?: string): JSX.Element => {
  const type = getFileIconType(name) || "file";
  return getCommandIcon(type);
};
